import Ajax from '@/lib/ajax'
import Utils from '@/lib/util'

export default {
  getList(pageSize: number, currentPage: number, keyWord?: string) {
    return Ajax.post('api/ExternData/ShopInfo/PagedStore', {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      KeyWord: keyWord
    })
  },
  getList2(pageSize: number, currentPage: number, keyWord?: string) {
    let params = {
      KeyWord: keyWord,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      Sorting: 'creationTime desc'
    }
    return Ajax.get(`/api/Vip/Public/ShopInfo`, {
      params: params
    })
  },
  getShopInfo(id: any) {
    return Ajax.get(`/api/Vip/Public/ShopInfo/${id}`)
  },
  editStoreInfo(id: any, obj: any) {
    return Ajax.put('/api/Vip/Public/ShopInfo/' + id, obj)
  },
  addStoreInfo(obj: any) { 
    return Ajax.post('/api/Vip/Public/ShopInfo', obj)
  },
  deleteStoreInfo(arr: any[]) {
    return Ajax.delete('/api/Vip/Public/ShopInfo' + Utils.serializeArr({ids: arr}))
  }
}
